"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const personalInformationSlice_1 = require("./personalInformationSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const utils_1 = require("../../../utils/utils");
const imageInput_1 = __importDefault(require("../../../components/documentUpload/imageInput/imageInput"));
const choices_1 = require("../../../utils/choices");
const input_1 = __importStar(require("../../../components/input/input"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const analytics_1 = require("../../../utils/analytics/analytics");
const network_1 = require("../../../utils/network");
const PersonalInformation = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const userData = (0, store_1.useAppSelector)((state) => state.home.user_data);
    const [titleStatus, setTitle] = (0, react_1.useState)(userData ? userData.personal_information.title : '');
    const [firstName, setFirstName] = (0, react_1.useState)(userData ? userData.personal_information.first_name : '');
    const [lastName, setLastName] = (0, react_1.useState)(userData ? userData.personal_information.last_name : '');
    const [gender, setGender] = (0, react_1.useState)(userData ? userData.personal_information.gender : '');
    const [dateOfBirth, setDateOfBirth] = (0, react_1.useState)(userData ? (0, utils_1.displayDate)(userData.personal_information.date_of_birth) : '');
    const [maritalStatus, setMaritalStatus] = (0, react_1.useState)(userData ? userData.personal_information.marital_status : '');
    const [numberDependents, setNumberDependents] = (0, react_1.useState)(userData ? userData.personal_information.number_of_dependents : '');
    const [educationalBackground, setEducationalBackground] = (0, react_1.useState)(userData ? userData.personal_information.educational_background : '');
    const [profilePhoto, setProfilePhoto] = (0, react_1.useState)(userData && userData.personal_information.profile_photo
        ? `${network_1.BASE_URL}${userData.personal_information.profile_photo.uri}`
        : {});
    const [profilePhotoName, setProfilePhotoName] = (0, react_1.useState)(userData ? userData.personal_information.profile_photo.name : '');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        let payload = {
            title: titleStatus,
            first_name: firstName.toString(),
            last_name: lastName.toString(),
            gender,
            date_of_birth: (0, utils_1.databaseDateFormat)(dateOfBirth.toString()),
            marital_status: maritalStatus,
            number_of_dependents: numberDependents,
            educational_background: educationalBackground,
        };
        const formDataPayload = new FormData();
        Object.entries(payload).forEach((entry) => {
            formDataPayload.append(entry[0], entry[1]);
        });
        // only add profile photo if it changes
        if (userData && profilePhoto !== `${network_1.BASE_URL}${userData.personal_information.profile_photo.uri}`) {
            // @ts-ignore
            const file = await fetch(profilePhoto).then((r) => r.blob());
            payload = {
                ...payload,
                profile_photo: file,
            };
            // @ts-ignore
            formDataPayload.append('profile_photo', file, profilePhotoName);
        }
        const result = await dispatch((0, personalInformationSlice_1.submitPersonalInformation)(formDataPayload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_personal_information',
            status: 'submitted',
            location: 'screen_PersonalInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_information',
                status: 'success',
                location: 'screen_PersonalInformation',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PROFILE_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_information',
                status: 'fail',
                location: 'screen_PersonalInformation',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "personalInformation_save" }), childrenTitle: "Personal information" },
        react_1.default.createElement(imageInput_1.default, { typeAvatar: true, toUploadTitle: "UPLOAD PHOTO", image: profilePhoto, setImage: setProfilePhoto, setImageName: setProfilePhotoName, error: (0, utils_1.getError)('profile_photo', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.titleChoices, label: "Title", value: titleStatus || '', setValue: setTitle, error: (0, utils_1.getError)('title', errors), optional: true }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "First name", placeholder: "First name", setValue: setFirstName, value: firstName, error: (0, utils_1.getError)('first_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Last name", placeholder: "Last name", setValue: setLastName, value: lastName, error: (0, utils_1.getError)('last_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Gender", choices: choices_1.genderChoices, setValue: setGender, value: gender || '', error: (0, utils_1.getError)('gender', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "Date of birth", setValue: setDateOfBirth, value: dateOfBirth, error: (0, utils_1.getError)('date_of_birth', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Marital status", choices: choices_1.maritalChoices, setValue: setMaritalStatus, value: maritalStatus || '', error: (0, utils_1.getError)('marital_status', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.familySizeChoices, label: "Number of dependents", setValue: setNumberDependents, value: numberDependents.toString() || '', error: (0, utils_1.getError)('number_of_dependents', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.educationalChoices, label: "Educational background", setValue: setEducationalBackground, value: educationalBackground || '', error: (0, utils_1.getError)('educational_background', errors) })));
};
exports.default = PersonalInformation;
